<template>
	<div class="draggable" id="draggable" data-class="unableDeactive" @mousedown="mouseDown" @contextmenu="RightClick" :style="{'cursor':spaceShow}">
		<div v-show="gridbackgroundOne&&mapType==2" :style="{'background': 'url('+gridbackground1+')no-repeat center'}" class="gridbackground gridbackground-1"></div>
		<div v-show="gridbackgroundTwo&&mapType==2" :style="{'background': 'url('+gridbackground2+')no-repeat center'}" class="gridbackground gridbackground-0625"></div>
		<div v-show="gridbackgroundThree&&mapType==2" :style="{'background': 'url('+gridbackground3+')no-repeat center'}" class="gridbackground gridbackground-05"></div>
		<div v-show="gridbackgroundFour&&mapType==2" :style="{'background': 'url('+gridbackground4+')no-repeat center'}" class="gridbackground gridbackground-03125"></div>
		<div v-show="gridbackgroundFive&&mapType==2" :style="{'background': 'url('+gridbackground5+')no-repeat center'}" class="gridbackground gridbackground-025"></div>
		<div :style="{ ...fatherNonTransform }" class="father_draggable" ref="father_draggable">
			<div class="positionInfo" v-show="active">
				<!--<span :style="{ ...nonTransformTwo}" class="count x1" ref="x1">{{x1}}</span>
				<span :style="{ ...nonTransformTwo} " class="count x2" ref="x2">{{x2}}</span>
				<span :style="{ ...nonTransform }" class="count y1" ref="y1">{{y1}}</span>
				<span :style="{ ...nonTransform }" class="count y2" ref="y2">{{y2}}</span>-->
			</div>
			<span :style="{ left: item.position, top: item.origin, height: item.lineLength}" class="ref-line v-line" v-for="item in vLine" v-show="item.display" />
			<span :style="{ top: item.position, left: item.origin, width: item.lineLength}" class="ref-line h-line" v-for="item in hLine" v-show="item.display" />


			<!--:disable-scale 保持内部元素不动-->
			<!--调整大小,位移都调用update-->
            <!--调整大小结束,位移结束都调用dragstop-->
			<FreeTransform
				:id="item.index"
				:index='item.index'
				v-for='(item,index) in draggable'
				v-if="item.ShowActive"
				:ref="item.index"
				:key="index"
				:item="item"
				:actualX="item.x"
				:actualY="item.y"
				:enableNativeDrag='true'
				:spaceMark="SpaceMark"
				:x="item.centerPointX"
				:y="item.centerPointY"
				:ifConduit="item.rotateDeg!=0||(item.id==11&&item.rotateDeg==0)"
				:scale-x="item.scaleX"
                :scale-y="item.scaleY"
				:width="item.fixeWidth"
				:height="item.fixeHeight"
				:Autowidth="item.width"
				:Autoheight="item.height"
				:angle="rotateDegAngle(item)"
				:disable-scale="item.type == 'span' || item.type == 'Divspan' || item.rotateDeg != 0 || (item.id==11&&item.rotateDeg == 0)"
				:selected="item.active"
                :styles="{zIndex:item.zIndex}"
                :zIndex="item.zIndex"
                :stylesoutline="{'outline':ActiveFreeborder(item),'margin':ActiveFreeMargin(item),'padding':ActiveFreePadding(item)}"
                :tr-transform="trTransform()"
                :class="[{activeDraggable:item.NowActive},item.type]"
                :aspect-ratio="true"
                :scale-from-center="true"
                selectOn="mousedown"
                @click.stop="ChangeClick(item,'Editor')"
				@onSelect="IfactiveTrue(item)"
                @update="dragging(item.index,item.type,$event)"
                @drag-end="dragstop(item.index,$event)"
				v-click-outside="{ fn: IfactiveFalse, arg:item }"
			>
				<div class="freebox"
                :style="{zIndex:item.zIndex}" >

                	<!--类型为文本标签时-->
                	<div class="typeSpan darkSpan" v-if="item.type === 'span'" :style="item.active ? {'overflow':'hidden','text-overflow':'ellipsis'}:{}">
                		<span :style="{background:item.bgColor,color:item.fontColor,fontSize:item.fontSize+'px'}">{{ item.divName }}</span>
                	</div>

                	<!--类型为属性看板时-->
					<div class="typeDivSpan"  v-if="item.type === 'Divspan'">
						<span>{{item.divName}}</span>
					</div>

					<!--类型为阀门时-->
					<div class="typeValve"  v-if="item.type === 'valve'" :style="{'background-image':'url('+item.ImgUrl+')'}">
						<!--<div class="LightShow state1" v-if="item.DeviceStateLightShow&&item.DeviceState==1"></div>
						<div class="LightShow state2" v-if="item.DeviceStateLightShow&&item.DeviceState==2"></div>
						<div class="LightShow state3" v-if="item.DeviceStateLightShow&&item.DeviceState==3"></div>
						<div class="LightShow state45" v-if="item.DeviceStateLightShow&&(item.DeviceState==4||item.DeviceState==5)"></div>-->
					</div>

					<!--类型为仪表时-->
					<div class="typeWatch"  v-if="item.type === 'watch'" :style="{'background-image':'url('+item.ImgUrl+')'}">
						<!--<div class="LightShow state1" v-if="item.DeviceStateLightShow&&item.DeviceState==1"></div>
						<div class="LightShow state2" v-if="item.DeviceStateLightShow&&item.DeviceState==2"></div>
						<div class="LightShow state3" v-if="item.DeviceStateLightShow&&item.DeviceState==3"></div>
						<div class="LightShow state45" v-if="item.DeviceStateLightShow&&(item.DeviceState==4||item.DeviceState==5)"></div>-->
					</div>

					<!--类型为管道时-->
					<div class="backgroundDiv" v-if="item.rotateDeg != 0||item.id == 11">
						<div class="conduit_show" :style="item.rotateDeg != 0||item.id == 11 ? backgroundDiv(item.ImgUrl,item.rotateDeg)  : {background:`none`}"></div>
						<div class="rotateDegGit" :class="{'XGif': item.direction==1&&item.rotateDeg===-30||item.direction==0&&item.rotateDeg!=-30}">
							<div class="Conduit_gif" :class="{'repeatTop':item.rotateDeg==90}" :style="item.thresholdMark?{'background-image': 'url('+item.imageGif+')'}:{'background-image': 'url('+item.imagePng+')'}"></div>
						</div>
					</div>

					<!--类型为设备img时-->
					<div class="typeImg" v-if="item.type === 'img'" :style="{'background-image':'url('+ImageBaseUrl+item.ImgUrl+')','width':item.width+'px','height':item.height+'px'}">
						<!--报警灯-->
						<div class="AlarmLightShow"
							:style="{'top': item.propertie.alarmLightY+'px','left': item.propertie.alarmLightX+'px'}"
							v-if="item.propertie.hasAlarmLight&&item.DeviceAlertLightShow"
							:class="AlarmLightShow(item)">
						</div>

						<!--状态灯-->
						<!--<div class="StateLightShow"
							:style="{'top': item.propertie.stateLightY+'px','left': item.propertie.stateLightX+'px'}"
							v-if="item.propertie.hasStateLight&&item.DeviceStateLightShow"
							:class="StateLightShow(item)">
						</div>-->

						<!--进度条-->
						<div class="ProgressBarShow"
							:style="{'top': item.propertie.progressBarY+'px','left': item.propertie.progressBarX+'px'}"
							v-if="item.propertie.hasProgressBar&&item.DeviceProgressLightShow"
							>
							<el-progress :show-text='false' :class="ProgressBarShow(item)" :stroke-width="8" :percentage="70"></el-progress>
						</div>
					</div>

					<!--类型为按钮时-->
					<div class="button" v-if="item.type === 'button'">
						<span>按钮</span>
					</div>

					<!--连接点 + 连接点斜对齐线-->
					<div :style="{'top': itemConnect.y+'px','left': itemConnect.x+'px'}" :x="itemConnect.x" :y="itemConnect.y" class="zIndexbottom" v-for="(itemConnect,index) in item.ConnectPoint" v-show="item.ConnectMark == true && itemConnect.Mark == true">
						<div class="SkewAlignment" :style="SkewAlingnmentDiv(item.rotateDeg)">
							<div :class="itemSkewAline.name" :style="{'width': itemSkewAline.width+'px'}" v-for="(itemSkewAline,index) in itemConnect.SkewAline" v-show="itemSkewAline.Mark == true"></div>
						</div>
					</div>

					<!--斜对齐线-->
					<div class="SkewAlignmentEQ">
						<div v-for="(itemSkewAline,index) in item.SkewAline" :class="itemSkewAline.name" v-show="itemSkewAline.Mark == true" :style="{'width': itemSkewAline.width+'px'}"></div>
					</div>

					<div v-if="item.rotateDeg!=0||item.id == 11">
						<!--近端转接头样式-->
						<div class="zjtClass" v-if="item.id!=10&&item.id!=11" :class="NearEndClassFun(item)" :style="item.rotateDeg === 30||item.rotateDeg===90?common.NearEnd(item.rotateDeg,item.NearNum,item.rotateDeg===30||item.rotateDeg===90?item.NearEndImgUrl:item.FarEndImgUrl):common.FarEnd(item.rotateDeg,item.FarNum,item.rotateDeg===30||item.rotateDeg===90?item.NearEndImgUrl:item.FarEndImgUrl)" v-show="item.rotateDeg===30||item.rotateDeg===90?item.NearEndMark:item.FarEndMark" ></div>

						<!--<img :class="NearEndClassFun(item)" :style="item.rotateDeg === 30||item.rotateDeg===90?common.NearEnd(item.rotateDeg,item.NearNum):common.FarEnd(item.rotateDeg,item.FarNum)" v-show="item.rotateDeg===30||item.rotateDeg===90?item.NearEndMark:item.FarEndMark" :src="item.rotateDeg===30||item.rotateDeg===90?item.NearEndImgUrl:item.FarEndImgUrl" />-->

						<!--远端转接头样式-->
						<div class="zjtClass" v-if="item.id!=10&&item.id!=11" :class="FarEndClassFun(item)" :style="item.rotateDeg === 30||item.rotateDeg===90?common.FarEnd(item.rotateDeg,item.FarNum,item.rotateDeg===30||item.rotateDeg===90?item.FarEndImgUrl:item.NearEndImgUrl):common.NearEnd(item.rotateDeg,item.NearNum,item.rotateDeg===30||item.rotateDeg===90?item.FarEndImgUrl:item.NearEndImgUrl)" v-show="item.rotateDeg===30||item.rotateDeg===90?item.FarEndMark:item.NearEndMark"></div>

            <!--近端转接头2d样式-->
            <div class="zjtClass zjt2d" :class="NearEndClassFun(item)" v-if="item.id==10||item.id==11"
                :style="common.NearEnd_2d(item.rotateDeg,item.NearNum,item.NearEndImgUrl)"
                v-show="item.NearEndMark"></div>

              <!--<img :class="NearEndClassFun(item)" :style="item.rotateDeg === 30||item.rotateDeg===90?common.NearEnd(item.rotateDeg,item.NearNum):common.FarEnd(item.rotateDeg,item.FarNum)" v-show="item.rotateDeg===30||item.rotateDeg===90?item.NearEndMark:item.FarEndMark" :src="item.rotateDeg===30||item.rotateDeg===90?item.NearEndImgUrl:item.FarEndImgUrl" />-->

              <!--远端转接头2d样式-->
              <div class="zjtClass zjt2d" :class="FarEndClassFun(item)" v-if="item.id==10||item.id==11"
                :style="common.FarEnd_2d(item.rotateDeg,item.FarNum,item.FarEndImgUrl)"
                v-show="item.FarEndMark"></div>

              <!--<img :class="FarEndClassFun(item)" :style="item.rotateDeg === 30||item.rotateDeg===90?common.FarEnd(item.rotateDeg,item.FarNum):common.NearEnd(item.rotateDeg,item.NearNum)" v-show="item.rotateDeg===30||item.rotateDeg===90?item.FarEndMark:item.NearEndMark" :src="item.rotateDeg===30||item.rotateDeg===90?item.FarEndImgUrl:item.NearEndImgUrl" />-->

          </div>
				</div>
			</FreeTransform>
		</div>
		<AttrBlackboard :companyId='companyId' :ref="attr"></AttrBlackboard>
		<div rightClick='1' class="rightList clearfix" :style="{'left': rightX+'px','top': rightY+'px'}" v-if="rightShowMark">
			<div class="rightList_box" rightClick='1' @click.stop="zIndexTopThis()">
				置顶
			</div>
			<div class="rightList_box" rightClick='1' @click.stop="zIndexBottomThis()">
				置底
			</div>
			<div class="rightList_box" rightClick='1' @click.stop="zIndexMoveUpThis()">
				上移一层
			</div>
			<div class="rightList_box" rightClick='1' @click.stop="zIndexMoveDownThis()">
				下移一层
			</div>
			<div class="rightList_box" rightClick='1' @click.stop="CopyDel()" style="margin-top: 1px;">
				剪切
			</div>
			<div class="rightList_box" rightClick='1' @click.stop="Copy()">
				复制
			</div>
			<div class="rightList_box" rightClick='1' @click.stop="PasteForDraggableThis()">
				粘贴
			</div>
			<div class="rightList_box" rightClick='1' @click.stop="DelForDraggableThis()">
				删除
			</div>
		</div>
		<div class="Direction" :class="{'dirA': mapType == 1, 'dirB': mapType == 2}"></div>
	</div>
</template>
<script>
	import FreeTransform from './FreeTransformCan.vue'
	import AttrBlackboard from './draggable/AttrBlackboardCan.vue'
	import { mapState } from 'vuex';
	import { mapMutations } from 'vuex';


	export default {
		components: {
	      FreeTransform,
	      AttrBlackboard
	    },
	    props: {
			companyId: {
		      type: Number,
		      request: true
		   	},
			mapType: {
				type: Number,
				request: 2
			},

		},
		data() {
			return {
				//记录当前点击拖拽时长(用于判断是否需要进行附着)
				clickTimeMark: null,
				TimeInerval: null,//当前鼠标按下时开始的计时器

				//判断空格按下
				SpaceMark: false,
				//当前编辑器偏移量
				editorLeft: 0,
				editorTop: 0,
				spaceNum: 0,//当前按下空格第几次
				spaceShow: '',//当前鼠标状态

				//存放复制数组
				WaitCopyArr: [],
				//存放复制偏移的x
				WaitCopyX: 1,

				//存放右键列表坐标
				rightShowMark: false,
				rightX: 0,
				rightY: 0,

				//判断当前是否只是点击
				handleClick: true,

				//存储当前移动的index是否为同一个 判断是否需要存入撤销状态中
				ChangeIndex: null,

				vLine: [],
				hLine: [],
				//方向键存储
				keyCodeArry: [],

				//标尺属性
				active: false, //判断标尺线标注是否需要
				x1: 0,
				x2: 0,
				y1: 0,
				y2: 0,
				NowIndex: -1, // 判断聚焦哪个图片

				//缩放属性
				slider: {
					ValueNum: 100,
				},

				attr: 'addrobot',

				//背景图片
				gridbackgroundOne: false,
				gridbackgroundTwo: false,
				gridbackgroundThree: false,
				gridbackgroundFour: false,
				gridbackgroundFive: false,

				gridbackground1: require('@/assets/image/editor/100.png'),
				gridbackground2: require('@/assets/image/editor/0625.png'),
				gridbackground3: require('@/assets/image/editor/05.png'),
				gridbackground4: require('@/assets/image/editor/03125.png'),
				gridbackground5: require('@/assets/image/editor/025.png'),
			}
		},
		computed: {
			...mapState("defaultImgOptions", {
				draggable: 'draggable',
				currentIndex: 'currentIndex',
				sync: 'sync',
				hasMove: 'hasMove',
				revokeDraggable: 'revokeDraggable',
				ImageBaseUrl: 'ImageBaseUrl',
				inputFocus: 'inputFocus'
			}),
			fireValue(){//监听vuex里存放图表的数组draggable
				return this.draggable;
			},
			draggingElement() {
				if(!this.NowIndex) return;
				return this.draggable.find(el => el.index == this.NowIndex);
			},
			SliderValue() {
				return this.slider.ValueNum;
			},
			scaleLevel() { //缩放等级:0.3-1
				return this.$store.getters['defaultImgOptions/getScaleLevel'];
			},
			fatherNonTransform() {
				return {
					transform: `scale(${this.scaleLevel})`,
					left: this.editorLeft*this.scaleLevel+'px',
					top: this.editorTop*this.scaleLevel+'px'
				};
			},

			nonTransform() {
				return {
					transform: `scale(${1 / this.scaleLevel})`
				};
			},
			ConnectPointStyle() {
				return {
					top: `${this.scaleLevel}`
				};
			},
			nonTransformTwo() {
				return {
					transform: `scale(${1 / this.scaleLevel}) translateX(-100%)`
				}
			}
		},
		mounted() {

			var self = this;
			sessionStorage.setItem('scaleLevel',this.scaleLevel)

			/*按下*/
			window.addEventListener('keydown', ev => {
				ev = ev || event;
				//console.log(ev.keyCode)

				if(ev.keyCode === 17) {
					self.syncTrue();
				}
				if(ev.keyCode === 37 || ev.keyCode === 38 || ev.keyCode === 39 || ev.keyCode === 40){
					if(self.NowIndex != -1){
						if(!self.keyCodeArry.includes(ev.keyCode)){
							self.keyCodeArry.push(ev.keyCode);
						}
						self.keyCodeDirection(self.keyCodeArry);
					}
				}

				//全选
				if(ev.keyCode == 65 && ev.ctrlKey){
					if(!self.inputFocus){
						self.AllChoice();
					}
				}

				//空格按下
				if(ev.keyCode == 32){
					self.SpaceMark = true;
					if(self.spaceNum == 0){
						self.spaceShow = 'grab'//切换当前手指状态
					}
					self.spaceNum++;
					if(ev.preventDefault){
				        ev.preventDefault();
				    }else{
				        window.event.returnValue = false;
				    }
				}

				//保存
				if(ev.keyCode == 83 && ev.ctrlKey){
					event.preventDefault();
					self.$emit('save')
				}

				//恢复
				if(ev.keyCode == 89 && ev.ctrlKey){
					if(!self.inputFocus){
						self.revokeStorage();//恢复之前要记录一次撤销状态
						self.RecoverStorageBack();
						self.$emit('updata')
					}
				}

				//撤销
				if(ev.keyCode == 90 && ev.ctrlKey){
					if(!self.inputFocus){
						self.RevokeStorageBack();
						self.$emit('updata')
					}
				}
				//剪切
				if(ev.keyCode == 88 && ev.ctrlKey){
					if(!self.inputFocus){
						self.CopyDel();
					}
				}
				//复制
				if(ev.keyCode == 67 && ev.ctrlKey){
					if(!self.inputFocus){
						self.Copy();
					}
				}
				//粘贴
				if(ev.keyCode == 86 && ev.ctrlKey){
					if(!self.inputFocus){
						self.PasteForDraggableThis();
					}
				}

				//删除
				if(ev.keyCode == 46){
					if(!self.inputFocus){
						self.DelForDraggableThis(self.NowIndex);
					}
				}

			});

			/*松开*/
			window.addEventListener('keyup', ev => {
				ev = ev || event;
				//空格松开
				if(ev.keyCode == 32){
					self.SpaceMark = false;
					self.spaceNum = 0;
					self.spaceShow = ''//切换当前手指状态
				}
				if(ev.keyCode === 17) {
					self.syncFalse();
				}
				if(ev.keyCode === 37 || ev.keyCode === 38 || ev.keyCode === 39 || ev.keyCode === 40){
					for(var a = 0; a<self.keyCodeArry.length;a++){
						if(self.keyCodeArry[a] == ev.keyCode){
							self.keyCodeArry.splice(a,1);
							self.keyCodeDirection(self.keyCodeArry);
						}
					}
				}
			});

			document.getElementById('draggable').addEventListener('mousewheel',self.handleScroll,false)//绑定滚轮事件
			if(self.scaleLevel == 1){
				self.gridbackgroundOne = true;
			}else if(self.scaleLevel == 0.625){
				self.gridbackgroundTwo = true;
			}else if(self.scaleLevel == 0.5){
				self.gridbackgroundThree = true;
			}else if(self.scaleLevel == 0.3125){
				self.gridbackgroundFour = true;
			}else if(self.scaleLevel == 0.25){
				self.gridbackgroundFive = true;
			}
			self.slider.ValueNum = this.scaleLevel * 100;

		},
		methods: {
			...mapMutations("defaultImgOptions", {
				CurrentPosition: 'CurrentPosition',
				ActiveForDraggable: 'ActiveForDraggable',
				ActiveForDraggableAllFalse: 'ActiveForDraggableAllFalse',
				CopyForDraggable: 'CopyForDraggable',
				DelForDraggable: 'DelForDraggable',
				scaleLevelModify: 'scaleLevelModify',
				NowActiveModifyTrue: 'NowActiveModifyTrue',
				NowActiveModifyFalse: 'NowActiveModifyFalse',
				ObliqueAlignment: 'ObliqueAlignment',
				ConnectPointMarkModify: 'ConnectPointMarkModify',
				AutoAttachConnectPoint: 'AutoAttachConnectPoint',
				SkewAlignmentShow: 'SkewAlignmentShow',
				SkewAlignmentClose: 'SkewAlignmentClose',
				keyCodeDirection: 'keyCodeDirection',
				currentIndexModify: 'currentIndexModify',
				ConnectionPointUpdata: 'ConnectionPointUpdata',
				SkewAlignmentEquipmentClose: 'SkewAlignmentEquipmentClose',
				SkewAlignmentEquipmentShow: 'SkewAlignmentEquipmentShow',
				AutoAttachSkewAlignment: 'AutoAttachSkewAlignment',
				AutoAttachEquiSkewAlignment: 'AutoAttachEquiSkewAlignment',
				syncTrue: 'syncTrue',
				syncFalse: 'syncFalse',
				ConnectionPointTest: 'ConnectionPointTest',
				ClickShowMarkUpdata: 'ClickShowMarkUpdata',
				revokeStorage: 'revokeStorage',
				RevokeStorageBack: 'RevokeStorageBack',
				RecoverStorageBack: 'RecoverStorageBack',
				zIndexTop: 'zIndexTop',
				zIndexBottom: 'zIndexBottom',
				zIndexMoveUp: 'zIndexMoveUp',
				zIndexMoveDown: 'zIndexMoveDown',
				CopyDelForDraggable: 'CopyDelForDraggable',
				editorLeftUpdata: 'editorLeftUpdata',
				editorTopUpdata: 'editorTopUpdata',
				AllChoice: 'AllChoice',
			}),
      updateStyle(i){
        console.log(this.draggable.filter(item => item.index == i)[0])
        this.$forceUpdate()
      },
			editorClear(){
				this.editorLeft = 0
				this.editorTop = 0
			},
			RightClick(){
				let self = this;
				var evt = window.event || arguments[0];
				var startX = (evt.x || evt.clientX);
				var startY = (evt.y || evt.clientY);

				self.rightX = startX - 320;
				self.rightY = startY - 99;
				self.rightShowMark = true;
			},
			getOffsetTop(obj){
			    var tmp = obj.offsetTop;
			    var val = obj.offsetParent;
			    while(val != null){
			        tmp += val.offsetTop;
			        val = val.offsetParent;
			    }
			    return tmp;
			},
			getOffsetLeft(obj){
			    var tmp = obj.offsetLeft;
			    var val = obj.offsetParent;
			    while(val != null){
			        tmp += val.offsetLeft;
			        val = val.offsetParent;
			    }
			    return tmp;
			},
			mouseDown(event){
				if(this.SpaceMark){
					var self = this;
					self.spaceShow = 'grabbing'
					var evt = window.event || arguments[0];
					var startX = (evt.x || evt.clientX);
					var startY = (evt.y || evt.clientY);
					var nowLeft = this.editorLeft;
					var nowTop = this.editorTop;
					const drag = () => {
						evt = window.event || arguments[0];
						let _x = (evt.x || evt.clientX),
						_y = (evt.y || evt.clientY);
						let x = (_x - startX)/self.scaleLevel,
						y = (_y - startY)/self.scaleLevel;
						self.editorLeft = nowLeft+x;
						self.editorTop = nowTop+y;
					}
					const up = () => {
						if(self.spaceShow == 'grabbing'){
							self.spaceShow = 'grab'
						}
						document.removeEventListener('mousemove',drag);
						document.removeEventListener('mouseup',up);
					}
					document.addEventListener('mousemove', drag);
					document.addEventListener('mouseup', up);
				}else{
					var targ
					if(!e) var e = window.event
					if(e.target) targ = e.target
					else if(e.srcElement) targ = e.srcElement
					if(targ.nodeType == 3) // defeat Safari bug
						targ = targ.parentNode

					if(targ.getAttribute('rightClick') == null){
						this.rightShowMark = false;
					}else{
						return;
					}
					var fatherTop = this.getOffsetTop(document.getElementById("draggable"))
					var fatherLeft = this.getOffsetLeft(document.getElementById("draggable"))
					var self = this;
					var selList = [];
					var fileNodes = document.getElementsByTagName("div");
					for(var i = 0; i < fileNodes.length; i++) {
						if(fileNodes[i].className.indexOf("fileDiv") != -1) {
							fileNodes[i].className = "fileDiv";
							selList.push(fileNodes[i]);
						}
					}

					var isSelect = true;
					var evt = window.event || arguments[0];
					var startX = (evt.x || evt.clientX);
					var startY = (evt.y || evt.clientY);
					var selDiv = document.createElement("div");
					selDiv.style.cssText = "position:absolute;width:0px;height:0px;font-size:0px;margin:0px;padding:0px;border:1px dashed #0099FF;background-color:#C3D5ED;z-index:1000;filter:alpha(opacity:60);opacity:0.6;display:none;";
					selDiv.id = "selectDiv";
					document.body.appendChild(selDiv);

					selDiv.style.left = startX + "px";
					selDiv.style.top = startY + "px";

					var _x = null;
					var _y = null;
	//				self.clearEventBubble(evt);

					document.onmousemove = function() {
						evt = window.event || arguments[0];
						if(isSelect) {
							if(selDiv.style.display == "none") {
								selDiv.style.display = "";
							}
							_x = (evt.x || evt.clientX);
							_y = (evt.y || evt.clientY);
							selDiv.style.left = Math.min(_x, startX) + "px";
							selDiv.style.top = Math.min(_y, startY) + "px";
							selDiv.style.width = Math.abs(_x - startX) + "px";
							selDiv.style.height = Math.abs(_y - startY) + "px";

							// ---------------- 关键算法 ---------------------
							var _l = selDiv.offsetLeft-fatherLeft,
              _t = selDiv.offsetTop-fatherTop,
              _w = selDiv.offsetWidth,
              _h = selDiv.offsetHeight;
//							console.log(_l,_t,_w,_h)
              for(var i = 0; i < selList.length; i++) {
                let width = Number(selList[i].getAttribute('autowidth'))*self.scaleLevel;
                let height = Number(selList[i].getAttribute('autoheight'))*self.scaleLevel;
                let x = Number(selList[i].getAttribute('actualx'))*self.scaleLevel;
                let y = Number(selList[i].getAttribute('actualy'))*self.scaleLevel;
  //							console.log(width,height,x,y)
                let DragWidth = document.getElementById('draggable').offsetWidth;
                let DragHeight = document.getElementById('draggable').offsetHeight;
                /*
                 * 差值计算公式
                 * (当前编辑器宽高度-(当前编辑器宽高度*缩放等级))/2
                 * */
                let deltaX = ((DragWidth - (DragWidth * self.scaleLevel))/ 2)+(self.editorLeft*self.scaleLevel);
                let deltaY = ((DragHeight - (DragHeight * self.scaleLevel))/ 2)+(self.editorTop*self.scaleLevel);
                var sl = deltaX + width + x;
                var st = deltaY + height + y;
                if(sl > _l && st > _t && x+deltaX < _l + _w && y+deltaY < _t + _h) {
                  if(selList[i].className.indexOf("seled") == -1) {
                    selList[i].className = selList[i].className + " seled";
                    if(self.scaleLevel == 1){
                      selList[i].className = selList[i].className + " seled1";
                    }else if(self.scaleLevel == 0.625){
                      selList[i].className = selList[i].className + " seled2";
                    }else if(self.scaleLevel == 0.5){
                      selList[i].className = selList[i].className + " seled3";
                    }else if(self.scaleLevel == 0.3125){
                      selList[i].className = selList[i].className + " seled4";
                    }else if(self.scaleLevel == 0.25){
                      selList[i].className = selList[i].className + " seled5";
                    }
                  }
                } else {
                  if(selList[i].className.indexOf("seled") != -1) {
                    selList[i].className = "fileDiv";
                  }
                }
              }
              self.clearEventBubble(evt);
            }
					}

					document.onmouseup = function() {
						isSelect = false;
						if(selDiv) {
							document.body.removeChild(selDiv);
							self.showSelDiv(selList);
						}
						selList = null, _x = null, _y = null, selDiv = null, startX = null, startY = null, evt = null,document.onmousemove = null,document.onmouseup = null;
					}
				}
			},
			clearEventBubble(evt) {
				if(evt.stopPropagation)
					evt.stopPropagation();
				else
					evt.cancelBubble = true;
				if(evt.preventDefault)
					evt.preventDefault();
				else
					evt.returnValue = false;
			},

			showSelDiv(arr) {
				var selInfo = [];
				for(var i = 0; i < arr.length; i++) {
					if(arr[i].className.indexOf("seled") != -1) {
						selInfo.push(parseInt(arr[i].getAttribute('index')))
					}
				}
				this.clickTimeMark = true;
				if(this.sync){
					/*按住ctrl*/
					for(let arr of selInfo){
						this.ActiveForDraggable({index: arr,Mark: true});
					}
				}else{
					/*没按ctrl*/
					this.ActiveForDraggableAllFalse()
					if(selInfo.length > 1){
						this.NowIndex = null;
						this.currentIndexModify(null);
						for(let arr of selInfo){
							this.ActiveForDraggable({index: arr,Mark: true});
						}
						this.NowActiveModifyTrue(selInfo[0]);
					}else if(selInfo.length == 1){
						this.NowIndex = selInfo[0];
						this.currentIndexModify(selInfo[0]);
						this.ActiveForDraggable({index: selInfo[0],Mark: true});
						this.NowActiveModifyTrue(selInfo[0]);
					}
				}

			},
			/*报警灯颜色类名Change*/
			AlarmLightShow(item){

			},
			/*状态指示灯颜色类名Change*/
			StateLightShow(item){

			},
			/*进度条颜色类名Change*/
			ProgressBarShow(item){
				return 'blueBystate ProgressUnset'
			},
			//根据缩放比例调整按钮大小
			trTransform(){
				if(Number(this.scaleLevel) == 1){
					return {
						transform: `scale(1)`,
					}
				}else if(Number(this.scaleLevel) == 0.625){
					return {
						transform: `scale(1.8)`,
					}
				}else if(Number(this.scaleLevel) == 0.5){
					return {
						transform: `scale(2.3)`,
					}
				}else if(Number(this.scaleLevel) == 0.3125){
					return {
						transform: `scale(3.3)`,
					}
				}else if(Number(this.scaleLevel) == 0.25){
					return {
						transform: `scale(4.3)`,
					}
				}
			},
			ActiveFreeborder(item){
				if(item.active){
					if(!this.clickTimeMark){
						if(Number(this.scaleLevel) == 1){
							return "2px solid rgb(132 58 58) !important"
						}else if(Number(this.scaleLevel) == 0.625){
							return "3px solid rgb(132 58 58) !important"
						}else if(Number(this.scaleLevel) == 0.5){
							return "4px solid rgb(132 58 58) !important"
						}else if(Number(this.scaleLevel) == 0.3125){
							return "5px solid rgb(132 58 58) !important"
						}else if(Number(this.scaleLevel) == 0.25){
							return "6px solid rgb(132 58 58) !important"
						}
					}else{
						if(Number(this.scaleLevel) == 1){
							return "2px solid #607d8b !important"
						}else if(Number(this.scaleLevel) == 0.625){
							return "3px solid #607d8b !important"
						}else if(Number(this.scaleLevel) == 0.5){
							return "4px solid #607d8b !important"
						}else if(Number(this.scaleLevel) == 0.3125){
							return "5px solid #607d8b !important"
						}else if(Number(this.scaleLevel) == 0.25){
							return "6px solid #607d8b !important"
						}
					}
				}
			},
			ActiveFreePadding(item){
				if(item.active){
					if(item.rotateDeg == 30){
						return '5px 0px 1px 7px'
					}else if(item.rotateDeg == -30){
						return '0px 5px 5px 3px'
					}else if(item.rotateDeg == 90){
						return '0px 3px 0px 3px'
					}
				}
			},
			ActiveFreeMargin(item){
				if(item.active){
					if(item.rotateDeg == 30){
						return '-3px 0px 0px -3px'
					}else if(item.rotateDeg == -30){
						return '-3px 0px 0px -3px'
					}else if(item.rotateDeg == 90){
						return '0px 0px 0px -3px'
					}
				}
			},

			rotateDegAngle(item){
				if(item.rotateDeg == 90 || item.rotateDeg == 0){
					return 0
				}else{
					return item.rotateDeg
				}
			},
			ClassName(item){
				return item.type
			},
			resizable(item){
				if(item.rotateDeg != 0 || item.type == 'span'|| item.id==11 ){
					return true
				}else{
					return false
				}
			},
			resizeHandler(item){
				if(item.rotateDeg == 90){
					return ['tm','bm']
				}else if(item.rotateDeg == -30 || item.rotateDeg == 30 || item.type == 'span'){
					return ['r','l']
				}

			},
			NearEndClassFun(item){
				if(item.rotateDeg == 30){
					return 'NearEnd30'
				}else if(item.rotateDeg == 90){
					return 'NearEnd90'
				}else{
					return 'FarEnd30'
				}
			},
			FarEndClassFun(item){
				if(item.rotateDeg == 30){
					return 'FarEnd30'
				}else if(item.rotateDeg == 90){
					return 'FarEnd90'
				}else{
					return 'NearEnd30'
				}
			},
			ValueDDR(item) {
				if(item.rotateDeg === 90 || item.rotateDeg === 0){
					return {x: item.x, y: item.y, width: item.width, height: item.height, rotation: 0, zIndex: item.zIndex}
				}else{
					return {x: item.x, y: item.y, width: item.width, height: item.height, rotation: item.rotateDeg, zIndex: item.zIndex}
				}
			},
			handleScroll (e) {
				e.stopPropagation();
				e.preventDefault();
                var direction = e.deltaY>0?'down':'up' //该语句可以用来判断滚轮是向上滑动还是向下
              	if(direction == 'down'){
              		if(this.slider.ValueNum == 100){
              			this.slider.ValueNum = 62.5;
              		}else if(this.slider.ValueNum == 62.5){
              			this.slider.ValueNum = 50;
              		}else if(this.slider.ValueNum == 50){
              			this.slider.ValueNum = 31.25;
              		}else if(this.slider.ValueNum == 31.25){
              			this.slider.ValueNum = 25;
              		}
              	}else if(direction == 'up'){
              		if(this.slider.ValueNum == 25){
              			this.slider.ValueNum = 31.25;
              		}else if(this.slider.ValueNum == 31.25){
              			this.slider.ValueNum = 50;
              		}else if(this.slider.ValueNum == 50){
              			this.slider.ValueNum = 62.5;
              		}else if(this.slider.ValueNum == 62.5){
              			this.slider.ValueNum = 100;
              		}
              	}
           	},
			SkewAlingnmentDiv(rotateDeg){
				if(rotateDeg != 90){
					return {
						transform: `rotate(${-rotateDeg}deg)`,
					}
				}
			},

			backgroundDiv(imgurl,rotateDeg){
				if(rotateDeg == 30 || rotateDeg == -30 || rotateDeg == 0){
					return {
			        	backgroundImage: 'url(' + imgurl + ')',
			        	backgroundRepeat: 'repeat-x'
			        }
				}else if(rotateDeg == 90){
					return {
			        	backgroundImage: 'url(' + require('@/assets/image/editor/gray_top.png') + ')',
			        	backgroundRepeat: 'repeat-y',
			        	'transform-origin': '100% 100%',
			        }
				}
			},
			getRefLineParams(params) {
				const {
					vLine,
					hLine
				} = params

				this.vLine = vLine
				this.hLine = hLine
			},
			//置顶
			zIndexTopThis(){
				this.revokeStorage();/*存储撤销状态*/
				this.zIndexTop();
				this.rightShowMark = false;
			},
			//置底
			zIndexBottomThis(){
				this.revokeStorage();/*存储撤销状态*/
				this.zIndexBottom();
				this.rightShowMark = false;
			},
			//上移一层
			zIndexMoveUpThis(){
				this.revokeStorage();/*存储撤销状态*/
				this.zIndexMoveUp();
				this.rightShowMark = false;
			},
			//下移一层
			zIndexMoveDownThis(){
				this.revokeStorage();/*存储撤销状态*/
				this.zIndexMoveDown();
				this.rightShowMark = false;
			},

			//剪切
			CopyDel(){
				this.rightShowMark = false;
				this.revokeStorage();/*存储撤销状态*/
				this.active = false;
				this.NowIndex = -1;
				var arr = [];
				for(let dragg of this.draggable){
					if(dragg.active){
						arr.push(dragg);
					}
				}
				this.WaitCopyArr = arr;
				this.DelForDraggable();
			},
			//复制
			Copy(){
				this.rightShowMark = false;
				var arr = [];
				for(let dragg of this.draggable){
					if(dragg.active){
						arr.push(dragg);
					}
				}
				this.WaitCopyArr = arr;
				this.WaitCopyX = 1;
			},
			//粘贴
			PasteForDraggableThis() {
				this.revokeStorage();/*存储撤销状态*/
				this.rightShowMark = false;
				this.WaitCopyX++;
				this.CopyDelForDraggable([this.WaitCopyArr,this.WaitCopyX]);
			},
			//删除
			DelForDraggableThis(index) {
				this.revokeStorage();/*存储撤销状态*/
				this.rightShowMark = false;
				this.active = false;
				this.NowIndex = -1;
				this.currentIndexModify(-1);
				this.DelForDraggable();
			},
			//斜向对齐
			ObliqueAlignmentThis(index) {
				this.revokeStorage();/*存储撤销状态*/
				this.ObliqueAlignment(index);
			},

			IfactiveTrue(item,t) {
				/*将文本框失焦*/
				this.$emit('inputBlur');

				if(this.draggable.filter(item => item.active == true).length <= 1){
					this.clickTimeMark = false;
					this.TimeInerval = setTimeout(() => {
						this.clickTimeMark = true;
					},300)
				}else{
					this.clickTimeMark = true;
				}

				this.rightShowMark = false;
				var index = item.index;
				this.ChangeIndex = 1;
				if(!this.sync){
					if(this.draggable.filter(item => item.active == true).length <= 1){
						this.ActiveForDraggableAllFalse();
					}
				}

				//更改当前选中元素的active
				this.ActiveForDraggable({index: index,Mark: true});
				//显示当前首选设备 连接点;切换当前首选状态
				this.NowActiveModifyTrue(index);
				this.NowIndex = index;
				this.currentIndexModify(this.NowIndex);

				//当选中元素时 显示标尺线标注
				this.active = true;
			},
			ChangeClick(item,type){
				// console.log('click')
				this.ChangeIndex = 0;
        this.$emit('hideGrid')
				clearTimeout(this.TimeInerval);
				this.handleClick = true;
				if(type != 'Editor' && item.type == 'Divspan' && item.DeviceMoth != null){
					this.Addrobot(item.index);
				}else if(type != 'Editor' && item.type == 'img' && item.DeviceId != null){
					this.Addrobot(item.index);
				}
        this.$forceUpdate()
			},
			IfactiveFalse(item,event) {

				var index = item.index;
				event = event || window.event;
				let path = event.path || (event.composedPath && event.composedPath());
				const target = event.target || event.srcElement;

				function unableDeactive(ele) {//检测是否不予许失焦
					return (
						ele.getAttribute && ele.getAttribute('data-class') == 'unableDeactive'
					);
				}
				if(index == this.NowIndex){
					if (path.some(unableDeactive)) {
						if(!this.rightShowMark){
							if(!this.sync) {
								//当不选中元素时 不显示标尺线标注
								this.NowIndex = -1; //取消聚焦
								this.currentIndexModify(this.NowIndex);
								this.ActiveForDraggableAllFalse();
							}
							this.active = false;
							//取消当前首选状态
							this.NowActiveModifyFalse();
						}
					}
				}
			},

			//调整大小与移动元素时
			dragging(id,type,payload) {
				var widthChange = payload.widthHandle != undefined?true:false;
				var scaleChange = payload.scaleX != undefined?true:false;
				var countChange = payload.x != undefined?true:false;
				if(countChange){
					var x = payload.stopX;
					var y = payload.stopY;
					var centerPointX = payload.x;
					var centerPointY = payload.y;
				}
				if(payload.Change == 'handleTranslation'){
					if(!this.clickTimeMark)return;
					if(this.ChangeIndex == 1){
						this.revokeStorage();/*存储撤消状态*/
					}
					if(this.draggable.filter(item => item.active != false).length > 1){
						//多选
						const offsetX = Math.round(centerPointX) - this.draggingElement.centerPointX;
						const offsetY = Math.round(centerPointY) - this.draggingElement.centerPointY;
						const deltaX = this.deltaX(offsetX);
						const deltaY = this.deltaY(offsetY);

						this.draggable.map(el => {
							if(el.index !== id && el.active) {
								this.CurrentPosition({
									index: el.index,
									Change: 'positionCount',
									centerPointX: Math.round(el.centerPointX + offsetX),
									centerPointY: Math.round(el.centerPointY + offsetY),
									x: Math.round(el.x + offsetX),
									y: Math.round(el.y + offsetY)
								});
							}
							return el;
						});
					}

					//修改画布里当前聚焦元素的x，y
					this.CurrentPosition({index: id,Change: 'positionCount',centerPointX: Math.round(centerPointX),centerPointY: Math.round(centerPointY),x: Math.round(x),y: Math.round(y)});
					//显示斜对齐线
					this.SkewAlignmentShow(id)
					//显示设备斜对齐线
					this.SkewAlignmentEquipmentShow(id)
					//显示连接点
					/*this.ConnectPointMarkModify(id)*/
					this.ChangeIndex++;
				}else if(payload.Change == 'handleScale'){
					if(scaleChange){
						var scaleX = payload.scaleX;
						var scaleY = payload.scaleY;
					}
					if(widthChange){
						var width = payload.widthHandle;
						var height = payload.heightHandle;
					}
					//重新渲染连接点
					this.ConnectionPointUpdata({index:id,width:width,height:height})
					//显示斜对齐线
					this.SkewAlignmentShow(id)
					//修改画布里当前聚焦元素的x,y
					this.CurrentPosition({index: id,Change: 'positionCount',centerPointX: Math.round(centerPointX),centerPointY: Math.round(centerPointY),x: Math.round(x),y: Math.round(y)});
					//修改画布里当前聚焦元素的width,height
					this.CurrentPosition({index: id,Change: 'positionWidth',width: width,height: height});
					//修改画布里当前聚焦元素的scaleX,scaleY
					this.CurrentPosition({index: id,Change: 'scaleChange',scaleX: scaleX,scaleY: scaleY});

				}
				this.handleClick = false;
			},
			//停止调整大小与停止移动元素时
			dragstop(id,payload) {
				if(!this.clickTimeMark)return;
				let mark = false;//判断是否需要吸附
				let NowChoiceNum = 0;//当前选中的数量
				if(!this.handleClick){
					for(let drag of this.draggable){
						if(drag.active){
							NowChoiceNum++;
						}
					}
					if(NowChoiceNum == 1){
						/*判断当前是否只选中一个组件*/
						mark = true;
					}
					if(payload && mark){
						var x = payload.stopX
						var y = payload.stopY
						var centerPointX = payload.centerPointX
						var centerPointY = payload.centerPointY;
						if(payload.Change == 'handleTranslation'){
							this.CurrentPosition({
								index: id,
								Change: 'positionCount',
								centerPointX: Math.round(centerPointX),
								centerPointY: Math.round(centerPointY),
								x: Math.round(x),
								y: Math.round(y)
							}); //修改画布里当前聚焦元素的x，y
							//自动附着设备斜对齐线
							this.AutoAttachEquiSkewAlignment(id);//将当前聚焦index与相应的x，y轴放入obj
							//自动附着连接点
							this.AutoAttachConnectPoint(id);//将当前聚焦index与相应的x，y轴放入obj
							//自动附着斜对齐线
							this.AutoAttachSkewAlignment(id);//将当前聚焦index与相应的x，y轴放入obj


							/*//隐藏斜对齐线
							this.SkewAlignmentClose(id)
							//隐藏设备斜对齐线
							this.SkewAlignmentEquipmentClose(id)*/
						}else if(payload.Change == 'handleScale'){
							/*//隐藏斜对齐线
							this.SkewAlignmentClose(id)
							//隐藏设备斜对齐线
							this.SkewAlignmentEquipmentClose(id)*/
						}
					}
					//隐藏斜对齐线
					this.SkewAlignmentClose(id)
					//隐藏设备斜对齐线
					this.SkewAlignmentEquipmentClose(id)
				}
			},
			Addrobot(index) {
				var self = this;
				/*展示属性看板*/
				this.ClickShowMarkUpdata(index);
				if(this.$refs.addrobot.$el.style.display == "" || this.$refs.addrobot.$el.style.display == "none") {
					this.$refs.addrobot.binding(this.draggable.filter(item => item.index==index)[0]);
					this.$refs.addrobot.$el.style.display = "block";
					setTimeout(function() {
						self.$refs.addrobot.$el.style.opacity = 1;
						self.$refs.addrobot.$children[0].$el.style.top = 0 + 'px';
					}, 50)
				} else {
					this.$refs.addrobot.$el.style.opacity = 0;
					self.$refs.addrobot.$children[0].$el.style.top = -50 + 'px';
					setTimeout(function() {
						self.$refs.addrobot.$el.style.display = "none";
					}, 100)
				}
			},
			deltaX(offsetX) {
				const ret = offsetX - this.prevOffsetX;

				this.prevOffsetX = offsetX;

				return ret;
			},
			deltaY(offsetY) {
				const ret = offsetY - this.prevOffsetY;

				this.prevOffsetY = offsetY;

				return ret;
			},

		},
		beforeDestroy() {
			if(this.TimeInerval){
				clearTimeout(this.TimeInerval); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		watch: {
			sync(val){
				// console.log(val)
				if(val){
					this.clickTimeMark = true;

				}
			},
			editorLeft(val){
				this.editorLeftUpdata(val);
			},
			editorTop(val){
				this.editorTopUpdata(val);
			},
			currentIndex(val){
				if(val == -1){
					this.active = false;
				}else{
					this.active = true;
				}
				this.NowIndex = val;
			},
			fireValue:{
				handler:function(newValue, oldValue){
//					console.log(oldValue,newValue)
				},
				deep: true
			},
			scaleLevel(val){
				sessionStorage.setItem('scaleLevel',this.scaleLevel)
				this.slider.ValueNum = val * 100;
				if(val == 1){
					this.gridbackgroundOne = true;
					this.gridbackgroundTwo = false;
					this.gridbackgroundThree = false;
					this.gridbackgroundFour = false;
					this.gridbackgroundFive = false;
				}else if(val == 0.625){
					this.gridbackgroundTwo = true;
					this.gridbackgroundOne = false;
					this.gridbackgroundThree = false;
					this.gridbackgroundFour = false;
					this.gridbackgroundFive = false;
				}else if(val == 0.5){
					this.gridbackgroundThree = true;
					this.gridbackgroundTwo = false;
					this.gridbackgroundOne = false;
					this.gridbackgroundFour = false;
					this.gridbackgroundFive = false;
				}else if(val == 0.3125){
					this.gridbackgroundFour = true;
					this.gridbackgroundTwo = false;
					this.gridbackgroundOne = false;
					this.gridbackgroundThree = false;
					this.gridbackgroundFive = false;
				}else if(val == 0.25){
					this.gridbackgroundFive = true;
					this.gridbackgroundFour = false;
					this.gridbackgroundTwo = false;
					this.gridbackgroundOne = false;
					this.gridbackgroundThree = false;
				}
			},
			SliderValue(val) {
				this.$refs.father_draggable.style.transform = 'scale(' + val / 100 + ')';
				this.scaleLevelModify(val / 100)
			},
		},
	}
</script>
<style scoped>
	.Direction.dirB{
		color: red;
		background-image: url(../../../../assets/image/editor/Direction2.5.png);
	}
	.Direction.dirA{
		color: red;
		background-image: url(../../../../assets/image/editor/Direction2.png);
	}
	.Direction{
		background-repeat: no-repeat;
	    background-position: center;
	    background-size: contain;

		position: absolute;
		width: 96px;
		height: 86px;
		left: 0;
		bottom: 50px;
	}

	.darkSpan span{
		background:#505050cc;
		color: #FFFFFF;
		border-radius:5px;
	    padding: 13px 14px 11px 18px;
	    letter-spacing: 1px;
	}
	.ProgressBarShow >>> .ProgressTop .el-progress-bar__inner{
	    background-image: url(../../../../assets/image/editor/progresstop.png);
	}
	.ProgressBarShow >>> .ProgressBottom .el-progress-bar__inner{
	    background-image: url(../../../../assets/image/editor/progressbottom.png);
	}
	.ProgressBarShow >>> .ProgressUnset .el-progress-bar__inner{
	    background-image: url(../../../../assets/image/editor/progressH.png);
	}
	.ProgressBarShow >>> .blueBystate .el-progress-bar__inner{
		background-color: #2188DA !important;
	    background-repeat: repeat-x;
	    background-position: center;
	    background-size: 10px 10px;
	}
	.ProgressBarShow >>> .yellowBystate .el-progress-bar__inner{
		background-color: #FBAD34 !important;
	    background-repeat: repeat-x;
	    background-position: center;
	    background-size: 10px 10px;
	}
	.ProgressBarShow >>> .redBystate .el-progress-bar__inner{
		background-color: #F57A7A !important;
	    background-repeat: repeat-x;
	    background-position: center;
	    background-size: 10px 10px;
	}

	.ProgressBarShow >>> .el-progress-bar__outer{
		background-color: #B9B9B9 !important;
	}

	.directionTwo{
		transform: rotate(180deg);
    	top: 1px;
	}
	.XGif{
		transform: rotate(180deg);
    	top: 1px;
	}
	.rotateDegGit{
		width: 100%;
		height: 100%;
		position: absolute;
		transform-origin: 50% 50%;

	}
	.rightList{
		position: absolute;
		width: 198px;
		background-color: #151515;
		color: #E6E6E6;
		font-size: 12px;
		border-radius: 1px;
		z-index: 999;
	}
	.rightList_box{
		float: left;
		text-indent: 18px;
		background-color: #353738;
		line-height: 36px;
		text-align: left;
		width: 100%;
		cursor: pointer;
	}
	.rightList_box:hover{
		background-color: #2571EF !important;

	}
	.tr-transform.Divspan {
		cursor: pointer;
	}

	.typeImg {
		position: absolute;
		background-position: center;
		background-size: 100%;
		background-repeat: no-repeat;
	}

	.repeatTop {
		background-repeat: repeat-y !important;
		background-size: 2.5px 42px !important;
		left: 2.5px !important;
	}

	.Conduit_gif {
		/*background-image: url(../../../../assets/image/editor/gray_gif.gif);*/
		background-repeat: repeat-x;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 3px;
		opacity: .4;
		background-size: 42px 2.5px;
	}

	.typeImg .AlarmLightShow {
		position: absolute;
		background-position: center;
		width: 21px;
		height: 24px;
	    background-size: auto;
		background-repeat: no-repeat;
		background-image: url(../../../../assets/image/material/errorLight.png);
	}

	.typeImg .StateLightShow {
		position: absolute;
		background-position: center;
		width: 13px;
		height: 10px;
		background-size: 100%;
		background-repeat: no-repeat;
		background-image: url(../../../../assets/image/material/green.png);
	}

	.typeImg .ProgressBarShow {
	    position: absolute;
	    background-position: center;
	    width: 64px;
	    height: 8px;
	    background-size: 100%;
	    background-repeat: no-repeat;
	    transform: rotate(-90deg);
	    /* background-image: url(../../../../assets/image/editor/Device/green_progress.png); */
	    transform-origin: 0 0;
	    margin-top: 64px;
	}

	.typeWatch .LightShow {
		position: absolute;
		background-position: center;
		width: 13px;
		height: 10px;
		background-size: 100%;
		background-repeat: no-repeat;
		top: -2px;
		left: -2px;
	}

	.typeWatch .LightShow.state1 {
		background-image: url(../../../../assets/image/editor/Device/green_point.png);
	}

	.typeWatch .LightShow.state2 {
		background-image: url(../../../../assets/image/editor/Device/red_point.png);
	}

	.typeWatch .LightShow.state3 {
		background-image: url(../../../../assets/image/editor/Device/yellow_point.png);
	}

	.typeWatch .LightShow.state45 {
		background-image: url(../../../../assets/image/editor/Device/gray_point.png);
	}

	.typeValve .LightShow {
		position: absolute;
		background-position: center;
		width: 13px;
		height: 10px;
		background-size: 100%;
		background-repeat: no-repeat;
		top: -6px;
		left: -6px;
	}

	.typeValve .LightShow.state1 {
		background-image: url(../../../../assets/image/editor/Device/green_point.png);
	}

	.typeValve .LightShow.state2 {
		background-image: url(../../../../assets/image/editor/Device/red_point.png);
	}

	.typeValve .LightShow.state3 {
		background-image: url(../../../../assets/image/editor/Device/yellow_point.png);
	}

	.typeValve .LightShow.state45 {
		background-image: url(../../../../assets/image/editor/Device/gray_point.png);
	}

	.typeSpan {
		width: 100%;
		height: 100%;
		color: #f5f5f5;
		font-size: 23px;
		text-align: center;
		white-space: nowrap;
	}

	.activeDraggable.conduit30>>>.tr-transform__scale-point--ml,
	.activeDraggable.conduit30>>>.tr-transform__scale-point--mr {
		display: block;
	}

	.activeDraggable.conduit-30>>>.tr-transform__scale-point--ml,
	.activeDraggable.conduit-30>>>.tr-transform__scale-point--mr {
		display: block;
	}

	.activeDraggable.conduit90>>>.tr-transform__scale-point--tm,
	.activeDraggable.conduit90>>>.tr-transform__scale-point--bm {
		display: block;
	}
  .activeDraggable.conduit90>>>.tr-transform__scale-point--tm,
  .activeDraggable.conduit90>>>.tr-transform__scale-point--bm {
  	display: block;
  }
  .activeDraggable.conduit0>>>.tr-transform__scale-point--lm,
  .activeDraggable.conduit0>>>.tr-transform__scale-point--rm {
  	display: block;
  }
	.tr-transform--active>>>.tr-transform__content {
		border: 0px !important;
	}

	.NearEnd30 {
		position: absolute;
		/*left: -20px;*/
		/*transform: rotate(-30deg);*/
		top: -10px;
	}

	.FarEnd30 {
		position: absolute;
		/*right: -25px;*/
		/*transform: rotate(-30deg);*/
		top: -8px;
	}

	.NearEnd90 {
		position: absolute;
		left: -9px;
		/*transform: rotate(-30deg);*/
		/*top: -10px;*/
	}

	.FarEnd90 {
		position: absolute;
		right: -11px;
		/*transform: rotate(-30deg);*/
		/*top: -8px;*/
	}

	.function {
		position: absolute;
		top: 0;
		right: 0;
		cursor: pointer;
		z-index: 10;
	}

	.function_img {
		width: 25px;
		height: 20px;
		text-align: center;
	}

	.function .function_img img {
		width: 18px;
		height: 5px;
	}

	.function .function_box {
		position: absolute;
		float: left;
		width: 65px;
		white-space: nowrap;
		z-index: 1;
		background-color: #252f40;
		-webkit-box-shadow: 0 0.1vw 0.3vw 0 rgba(0, 0, 0, .3);
		box-shadow: 0 0.1vw 0.3vw 0 rgba(0, 0, 0, .3);
		color: #fff;
		margin-top: 4px;
		border-radius: 1px;
	}

	.function .function_box div {
		width: 100%;
		height: 27px;
		line-height: 25px;
		letter-spacing: 1px;
	}

	.function .function_box div:hover {
		background-color: #131721;
		color: #28b3fc;
	}

	.vdr .button:hover {
		background-color: #CA3A45;
		color: #fff;
	}

	.vdr .button {
		border: 1.5px solid #CA3A45;
		border-radius: 3px;
		color: #CA3A45;
		width: 100%;
		height: 100%;
		cursor: pointer;
		background-color: #fff;
		font-size: 15px;
		-webkit-transition: .1s;
		transition: .1s;
		position: relative;
		/* margin: 20px;*/
	}

	.vdr .button span {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		width: auto;
		height: 20px;
		min-width: 30px;
		text-align: center;
	}

	.positionInfo .count {
		font-size: 10px;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		display: inline-block;
		width: auto;
		color: grey;
	}

	.positionInfo .x1,
	.positionInfo .x2 {
		position: absolute;
		top: -20px;
		left: 0;
		/*transform: scale(1.2) translateX(-100%);*/
		margin-left: 10px;
	}

	.positionInfo .y1,
	.positionInfo .y2 {
		position: absolute;
		top: 0;
		left: -20px;
		transform-origin: 100% -50%;
		/*transform: scale(1.2);*/
		margin-top: -8px;
	}

	.font {
		text-align: center;
		color: #fff;
	}

	.navigatorLine {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		pointer-events: none;
		box-sizing: content-box;
		/*display: none;*/
	}

	.navigatorLine .line {
		transform: scale(1);
	}

	.navigatorLine .topLine {
		position: absolute;
		z-index: 0;
		top: -.0625vw;
		left: -100vw;
		border-top: 1px dashed grey;
		width: 200vw;
		height: 0;
	}

	.navigatorLine .bottomLine {
		position: absolute;
		bottom: -.0625vw;
		border-top: 1px dashed grey;
		left: -100vw;
		width: 200vw;
		height: 0;
	}

	.navigatorLine .leftLine {
		position: absolute;
		left: -.0625vw;
		top: -100vh;
		border-left: 1px dashed grey;
		height: 250vh;
		width: 0;
	}

	.navigatorLine .rightLine {
		position: absolute;
		top: -100vh;
		right: -.0625vw;
		border-left: 1px dashed grey;
		height: 250vh;
		width: 0;
	}

	.SkewAlignment {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		pointer-events: none;
		box-sizing: content-box;
		z-index: 99;
	}

	.SkewAlignment .LeftTop {
		position: absolute;
		top: 50%;
		left: 50%;
		border-top: 0.5px solid #f0c;
		;
		width: 150px;
		height: 0;
		transform: rotate(-30deg);
		transform-origin: left top;
		display: none !important;
	}

	.SkewAlignment .LeftBottom {
		position: absolute;
		bottom: 0px;
		border-top: 0.5px solid #f0c;
		left: 50%;
		right: 0;
		top: 50%;
		height: 0;
		width: 150px;
		-webkit-transform: rotate(-150deg);
		transform: rotate(-150deg);
		transform-origin: left top;
	}

	.SkewAlignment .RightTop {
		position: absolute;
		top: 1px;
		right: 0;
		border-top: 0.5px solid #f0c;
		width: 150px;
		height: 0;
		transform: rotate(-150deg);
		transform-origin: right top;
	}

	.SkewAlignment .RightBottom {
		position: absolute;
		bottom: 0;
		right: 0;
		border-top: 0.5px solid #f0c;
		width: 150px;
		height: 0px;
		transform: rotate(-30deg);
		transform-origin: right bottom;
	}

	.SkewAlignment .LeftTop_vm {
		position: absolute;
		top: 50%;
		left: 50%;
		border-top: 0.5px solid #f0c;
		width: 150px;
		height: 0;
		transform: rotate(-210deg);
		transform-origin: left top;
		display: none !important;
	}

	.SkewAlignment .LeftBottom_vm {
		position: absolute;
		bottom: 0;
		border-top: 0.5px solid #f0c;
		left: 50%;
		height: 0;
		top: 50%;
		right: 0;
		width: 150px;
		-webkit-transform: rotate(30deg);
		transform: rotate(30deg);
		-webkit-transform-origin: left top;
		transform-origin: left top;
	}

	.SkewAlignment .RightTop_vm {
		position: absolute;
		top: 0vw;
		right: 0;
		border-top: 0.5px solid #f0c;
		width: 150px;
		height: 0;
		transform: rotate(30deg);
		transform-origin: right top;
	}

	.SkewAlignment .RightBottom_vm {
		position: absolute;
		/* top: 0vw; */
		bottom: 0;
		right: 0;
		/* left: 0; */
		border-top: 0.5px solid #f0c;
		width: 150px;
		height: 0px;
		transform: rotate(150deg);
		transform-origin: right bottom;
	}

	.Draggable-slider {
		position: absolute;
		bottom: 40px;
		right: 60px;
		width: 300px;
	}

	.Draggable-slider .box {
		width: 75px;
		float: left;
	}

	.Draggable-slider .box input {
		width: 100%;
	}

	.Draggable-slider .vue-slider.vue-slider-ltr {
		width: 200px !important;
		float: right !important;
	}

	.vue-slider-mark .vue-slider-mark-active {
		top: 100% !important;
	}

	.yoyoo-ddr.active {
		border: 0px !important;
		outline: 1px solid #607d8b !important;
	}

	.test {
		outline: 1px solid red !important;
	}

	.father_draggable {
		transform-origin: 50% 50%;
		width: 100%;
		height: 100%;
		position: absolute;
		background-position-x: 20px;
		z-index: 10;
		/*transition: .1s;*/
	}

	.draggable {
		position: relative;
		/*background: url(../../../../assets/image/editor/editor_bg.png)no-repeat center;*/
		/*transform-origin: 0px 0px;*/
	}

	.seled1>>>.tr-transform__content {
		outline: rgb(96, 125, 139) solid 2px !important;
	}

	.seled2>>>.tr-transform__content {
		outline: rgb(96, 125, 139) solid 3px !important;
	}

	.seled3>>>.tr-transform__content {
		outline: rgb(96, 125, 139) solid 4px !important;
	}

	.seled4>>>.tr-transform__content {
		outline: rgb(96, 125, 139) solid 5px !important;
	}

	.seled5>>>.tr-transform__content {
		outline: rgb(96, 125, 139) solid 6px !important;
	}

	.father_draggable .draggable .handle.handle-tl {
		margin-top: -5px;
		margin-left: -5px;
		display: block;
		cursor: unset;
	}

	.draggable .conduit {
		width: 100%;
		height: 100%;
	}

	.backgroundDiv {
		width: 100%;
		height: 100%;
		position: absolute;
	}

	.conduit_show {
		width: 100%;
		height: 100%;
		position: absolute;
		opacity: .7;
	}
	.typeDivSpan span{
		background: rgba(12,25,42,0.2);
	    border-radius: 5px;
	    text-decoration: underline;
	    color: rgba(70,158,255,1);
	    font-size: 23px;
	    line-height: 40px;
	}
	.typeDivSpan{
		width: 100%;
	    height: 100%;
	    /* color: #f5f5f5; */
	    font-size: 18px;
	    text-align: center;
	    white-space: nowrap;
	}
	.typeValve,
	.typeWatch {
		background-size: 100%;
		background-position: center;
		background-repeat: no-repeat;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
	}

	.zIndexbottom {
		z-index: 5 !important;
		position: absolute;
		display: block;
		cursor: unset;
		margin-top: -5px;
		margin-left: -5px;
		width: 10px;
		height: 10px;
		background-color: #166dff;
		border-radius: 50%;
	}

	.SkewAlignmentEQ {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		pointer-events: none;
		box-sizing: content-box;
	}

	.SkewAlignmentEQ .LeftTop {
		position: absolute;
		top: -1px;
		left: 0vw;
		border-top: 0.5px solid #f0c;
		;
		width: 150px;
		height: 0;
		transform: rotate(-30deg);
		transform-origin: left top;
	}

	.SkewAlignmentEQ .LeftBottom {
		position: absolute;
		bottom: -1px;
		border-top: 0.5px solid #f0c;
		left: 0;
		height: 0;
		width: 150px;
		transform: rotate(-150deg);
		transform-origin: left top;
	}

	.SkewAlignmentEQ .RightTop {
		position: absolute;
		top: 1px;
		right: 0;
		border-top: 0.5px solid #f0c;
		width: 150px;
		height: 0;
		transform: rotate(-150deg);
		transform-origin: right top;
	}

	.SkewAlignmentEQ .RightBottom {
		position: absolute;
		bottom: 0;
		right: 0;
		border-top: 0.5px solid #f0c;
		width: 150px;
		height: 0px;
		transform: rotate(-30deg);
		transform-origin: right bottom;
	}

	.SkewAlignmentEQ .LeftTop_vm {
		position: absolute;
		top: 0vw;
		left: 0vw;
		border-top: 0.5px solid #f0c;
		width: 150px;
		height: 0;
		transform: rotate(-210deg);
		transform-origin: left top;
	}

	.SkewAlignmentEQ .LeftBottom_vm {
		position: absolute;
		bottom: 0;
		border-top: 0.5px solid #f0c;
		left: 0;
		height: 0;
		width: 150px;
		transform: rotate(30deg);
		transform-origin: left top;
	}

	.SkewAlignmentEQ .RightTop_vm {
		position: absolute;
		top: 0vw;
		right: 0;
		border-top: 0.5px solid #f0c;
		width: 150px;
		height: 0;
		transform: rotate(30deg);
		transform-origin: right top;
	}

	.SkewAlignmentEQ .RightBottom_vm {
		position: absolute;
		/* top: 0vw; */
		bottom: 0;
		right: 0;
		/* left: 0; */
		border-top: 0.5px solid #f0c;
		width: 150px;
		height: 0px;
		transform: rotate(150deg);
		transform-origin: right bottom;
	}

	.activeDraggable>>>.tr-transform--active {
		position: absolute;
	}

	.activeDraggable>>>.tr-transform__content {
		user-select: none;
	}

	.activeDraggable>>>.tr-transform__content .element {
		padding: 5px;
	}

	.activeDraggable>>>.tr-transform__rotator {
		top: -45px;
		left: calc(50% - 7px);
	}

	.activeDraggable>>>.tr-transform__rotator,
	.activeDraggable>>>.tr-transform__scale-point {
		background: #fff;
		width: 9px;
		height: 9px;
		z-index: 10;
		border-radius: 50%;
		position: absolute;
		border: 1px solid rgba(0, 0, 0, 0.1);
		display: none;
	}

	.activeDraggable>>>.tr-transform__rotator:hover,
	.activeDraggable>>>.tr-transform__scale-point:hover {
		background: #F1F5F8;
	}

	.activeDraggable>>>.tr-transform__rotator:active,
	.activeDraggable>>>.tr-transform__scale-point:active {
		background: #DAE1E7;
	}

	.activeDraggable>>>.tr-transform__scale-point {}

	.activeDraggable>>>.tr-transform__scale-point--tl {
		top: -7px;
		left: -7px;
	}

	.activeDraggable.conduit30>>>.tr-transform__scale-point--ml {
		top: calc(50% - 6px);
		left: -5px;
		cursor: nw-resize;
	}

	.activeDraggable.conduit-30>>>.tr-transform__scale-point--ml {
		top: calc(50% - 6px);
		left: -7px;
		cursor: ne-resize;
	}

	.activeDraggable>>>.tr-transform__scale-point--tr {
		left: calc(100% - 7px);
		top: -7px;
	}

	.activeDraggable>>>.tr-transform__scale-point--tm {
		left: calc(50% - 5px);
		top: -7px;
		cursor: n-resize;
	}

	.activeDraggable.conduit30>>>.tr-transform__scale-point--mr {
		left: calc(100% - 6px);
		top: calc(50% - 6px);
		cursor: nw-resize;
	}

	.activeDraggable.conduit-30>>>.tr-transform__scale-point--mr {
		left: calc(100% - 7px);
		top: calc(50% - 5px);
		cursor: ne-resize;
	}
  /* 6.23添加2d X轴管道样式 （||item.id == 11  template新增判断 ）*/
  .activeDraggable.conduit0>>>.tr-transform__scale-point--lm {
  	left: 0;
  	top: -2px;
  	cursor: e-resize;
  }
  .activeDraggable.conduit0>>>.tr-transform__scale-point--rm {
		right: 0;
		top: -2px;
		cursor: e-resize;
	}

	.activeDraggable>>>.tr-transform__scale-point--bl {
		left: -7px;
		top: calc(100% - 7px);
	}

	.activeDraggable>>>.tr-transform__scale-point--bm {
		left: calc(50% - 5px);
		top: calc(100% - 7px);
		cursor: s-resize;
	}

	.activeDraggable>>>.tr-transform__scale-point--br {
		left: calc(100% - 7px);
		top: calc(100% - 7px);
	}

	.gridbackground {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		z-index: 5;
		/*display: none;*/
	}
	/*.gridbackground.gridbackground-1{
    	background: url(../../../../assets/image/editor/100.png)no-repeat center;
    }
    .gridbackground.gridbackground-0625{
    	background: url(../../../../assets/image/editor/0625.png)no-repeat center;
    }
    .gridbackground.gridbackground-05{
    	background: url(../../../../assets/image/editor/05.png)no-repeat center;
    }
    .gridbackground.gridbackground-03125{
    	background: url(../../../../assets/image/editor/03125.png)no-repeat center;
    }
    .gridbackground.gridbackground-025{
    	background: url(../../../../assets/image/editor/025.png)no-repeat center;
    }*/

	.tr-transform>>>.tr-transform__controls {
		z-index: 50;
	    /*outline: rgb(96, 125, 139) solid 1px !important;*/
	}
</style>



// WEBPACK FOOTER //
// src/components/MapEditor/canvas/Draggable/draggable.vue